import React, { useContext, useEffect } from 'react';

import Markup from '../../../../markup';
import Toggle from '../../../Global/Toggle';
import Count from '../../../Global/Count';
import BuilderContext from '../../../../builder/hooks/context';
import { trackSubStage, trackBeforeUnload } from '../../../../utils/Analytics';

function NameSize() {
  const { builder } = useContext(BuilderContext);

  const currentMemberSize = builder.membersData.members[builder.membersData.currentMemberIndex].data.size;
  
  useEffect(() => {
    trackSubStage('Specs', 'Size');
    trackBeforeUnload('Size');
  }, []);

  return (
    <>
      <Markup.Screen.Name.Wrapper>
        <Markup.Screen.Name.DisableOverlayOther themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}/>
        <Markup.Screen.Name.SpecItemSize>
          <Markup.Screen.Name.SpecItemText themeColor={builder.manifest.colorTheme}>Select size</Markup.Screen.Name.SpecItemText>
            <Toggle 
                active={currentMemberSize}
                setActive={item => {
                    builder.membersData.updateMember({ data: { size: item } });
                }} 
                items={builder?.options?.size.map(item => item?.toUpperCase())} 
                circle 
            />
        </Markup.Screen.Name.SpecItemSize>
        <Markup.Screen.Name.SpecItem>
          <Markup.Screen.Name.SpecItemText themeColor={builder.manifest.colorTheme}>Quantity</Markup.Screen.Name.SpecItemText>
          <Count value={builder.membersData.currentMember.data.quantity} setValue={item => builder.membersData.updateMember({ data: { quantity: item } })} max={10} min={1} />
        </Markup.Screen.Name.SpecItem>
      </Markup.Screen.Name.Wrapper>
    </>
  );
}

export default React.memo(NameSize);
